import { render, staticRenderFns } from "./QuoteOrm.vue?vue&type=template&id=f65babf4&scoped=true"
import script from "./QuoteOrm.vue?vue&type=script&lang=js"
export * from "./QuoteOrm.vue?vue&type=script&lang=js"
import style0 from "./QuoteOrm.vue?vue&type=style&index=0&id=f65babf4&prod&lang=scss&scoped=true"
import style1 from "./QuoteOrm.vue?vue&type=style&index=1&id=f65babf4&prod&lang=scss"
import style2 from "./QuoteOrm.vue?vue&type=style&index=2&id=f65babf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65babf4",
  null
  
)

export default component.exports